export default __webpack_public_path__ + "static/media/p1.12a05406.svg";